import moment from 'moment/moment';

const getFormats = () => ({
  weekdayFormat: (date, culture, local) => local.format(date, 'dddd', culture),
});

const isWeekend = date => {
  const day = moment(date).day();
  return day === 0 || day === 6; // Sunday = 0, Saturday = 6
};

const dayPropGetter = date => {
  if (isWeekend(date)) {
    return {
      className: 'rbc-weekend', // Custom class for weekend days
    };
  }
  return {};
};

const eventPropGetter = (event, start, end) => {
  const now = new Date();

  if (event?.status === 'canceled') {
    return {
      className: 'event-canceled',
    };
  }

  // Event in the past
  if (end < now) {
    return {
      className: 'event-past', // Add class for past events
    };
  }

  // Event is ongoing
  if (start <= now && end >= now) {
    return {
      className: 'event-ongoing', // Add class for ongoing events
    };
  }

  // Event in the future
  if (start > now) {
    return {
      className: 'event-future', // Add class for future events
    };
  }

  return {};
};

const groupEventsByDay = events => {
  const now = moment(); // Get the current moment

  // Helper function to determine event status
  const getEventStatus = (start, end, status) => {
    const eventStart = moment(start);
    const eventEnd = moment(end);

    if (status === 'canceled') {
      return 'canceled';
    }

    if (eventEnd.isBefore(now)) {
      return 'finished';
    }

    if (eventStart.isSameOrBefore(now) && eventEnd.isSameOrAfter(now)) {
      return 'ongoing';
    }

    return 'future';
  };

  // Group events by day
  return events.reduce((acc, event) => {
    const date = moment(event.start).format('YYYY-MM-DD'); // Format date as YYYY-MM-DD
    const status = getEventStatus(event.start, event.end, event.status); // Determine status

    // Initialize the day if it doesn't exist in the accumulator
    if (!acc[date]) {
      acc[date] = [];
    }

    // Add the event with status and timestamp
    acc[date].push({
      ...event,
      status,
    });

    return acc;
  }, {});
};

export { getFormats, dayPropGetter, eventPropGetter, groupEventsByDay };
